import { DTO, MenusResponse, VolusionApi } from './types';

export class Menus {
  constructor(private _api: VolusionApi, private _dto: DTO) {}

  public get(): Promise<MenusResponse> {
    return this._api.getMenus().then(this._dto.buildMenusResponse);
  }
}
